(function() {
  define('bazemont/content/page',['angular'], function() {
    'use strict';
    return angular.module('bazemontContentPage', []).component('bazemontContentPage', {
      templateUrl: '/assets/javascripts/bazemont/content/page.html',
      bindings: {
        pageId: '@'
      },
      controller: [
        '$scope', 'Page', 'TlhNotifierService', 'TlhCmsEvents', 'TlhScrollService', 'TlhNotificationService', 'TlhPositionService', function($scope, Page, TlhNotifierService, TlhCmsEvents, TlhScrollService, TlhNotificationService, TlhPositionService) {
          var cancelPageModifications, edited, handlePageChange, initialValue, savePageModifications, vm;
          vm = this;
          edited = false;
          initialValue = null;
          vm.$onInit = function() {
            return Page.get({
              id: vm.pageId
            }, function(result) {
              vm.page = result;
              return initialValue = angular.copy(vm.page);
            });
          };
          vm.moveSectionUp = function(section) {
            return TlhPositionService.moveElementUp(section, vm.page.sections);
          };
          vm.moveSectionDown = function(section) {
            return TlhPositionService.moveElementDown(section, vm.page.sections);
          };
          vm.addNewSection = function(position) {
            var section;
            if (position == null) {
              position = TlhPositionService.max(vm.page.sections) + 1;
            }
            TlhPositionService.increase(vm.page.sections, position);
            section = {
              isActive: true,
              position: position
            };
            return vm.page.sections.push(section);
          };
          savePageModifications = function() {
            var page, scrollTop;
            TlhNotificationService.info({
              message: 'Enregistrement en cours...',
              delay: false
            });
            scrollTop = TlhScrollService.getTop();
            page = new Page(vm.page);
            return page.$save().then(function(response) {
              if (response.success) {
                initialValue = angular.copy(response.page);
                vm.page = angular.copy(initialValue);
                TlhScrollService.setTop(scrollTop);
                TlhNotifierService.send(TlhCmsEvents.SAVE_SUCCESS);
                return TlhNotificationService.success({
                  message: 'Enregistrement terminé',
                  replaceMessage: true
                });
              }
            })["catch"](function(error) {
              var message;
              message = "L'enregistrement a échoué :<br>";
              message += error.data ? error.data : "Erreur inattendue, veuillez contacter l'administrateur.";
              TlhNotifierService.send(TlhCmsEvents.SAVE_FAILED);
              TlhNotificationService.error({
                message: message,
                replaceMessage: true,
                delay: false
              });
              return console.error(error);
            });
          };
          cancelPageModifications = function() {
            return vm.page = angular.copy(initialValue);
          };
          handlePageChange = function(newValue, oldValue) {
            if (newValue !== oldValue) {
              if (!edited && !angular.equals(newValue, initialValue)) {
                TlhNotifierService.send(TlhCmsEvents.PAGE_MODIFIED);
                edited = true;
              }
              if (edited && angular.equals(newValue, initialValue)) {
                TlhNotifierService.send(TlhCmsEvents.PAGE_UNMODIFIED);
                return edited = false;
              }
            }
          };
          $scope.$on(TlhCmsEvents.SAVE_ALL, savePageModifications);
          $scope.$on(TlhCmsEvents.CANCEL_ALL, cancelPageModifications);
          $scope.$watch(function() {
            return vm.page;
          }, handlePageChange, true);
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=page.js.map
;
